import React from 'react'
import Content from 'blocks.app/content/content'
import Editor from 'blocks.app/editor/editor'
import { checkAvailableModule } from '../../../core/helpers/routes/routes'
import { useSelector } from 'react-redux'
import styles from './broadcasts_addAdvanced.jcss'
import { RouteComponentProps } from 'react-router'
import { IRootState } from 'core/store/rootReducer'

interface IBroadcastsAddAdvancedProps extends RouteComponentProps {
    route?: unknown
}

const BroadcastsAddAdvanced = (p_: IBroadcastsAddAdvancedProps) => {
    const isMobile = useSelector((state: IRootState) => state.app.isMobile)

    return (
        <Content indentsMod={'none'} fullHeight={true} noPadding={isMobile} wrapperClassName={styles.wrapper}>
            <Editor route={p_.route} location={p_.location} />
        </Content>
    )
}

const exportBroadcastsAddAdvanced = checkAvailableModule('broadcasts/addAdvanced') ? BroadcastsAddAdvanced : null

export default exportBroadcastsAddAdvanced
